import React from 'react';
import cx from 'classnames';
import moment from 'moment';
moment.updateLocale('en', { weekdaysMin: 'S_M_T_W_T_F_S'.split('_') });
import TextField from '@mui/material/TextField';
import Popover from '@mui/material/Popover';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import FormControl from '@mui/material/FormControl';
import BackIcon from '@mui/icons-material/ArrowBackIos';
import ForwardIcon from '@mui/icons-material/ArrowForwardIos';
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";

const styles = require('./styles.pcss');

type Props = {
  onChange: Function;
  label: string;
  className?: any;
  error?: string;
  date: any;
  id: any;
  maxYear?: string;
  disabled?: boolean;
};

type State = {
  modalAnchor: any;
  date: any;
  focused: boolean;
};

class DatePickerComponent extends React.Component<Props, State> {
  containerRef: any;
  inputRef: any;

  constructor(props: Props) {
    super(props);

    this.state = {
      modalAnchor: null,
      date: props.date,
      focused: false,
    };

    this.containerRef = React.createRef();
    this.inputRef = React.createRef();
  }

  componentWillReceiveProps = (nextProps: Props) => {
    this.setState({
      date: nextProps.date,
    });
  };

  openModal = (event: any) => {
    this.setState({
      modalAnchor: this.containerRef,
      focused: true,
    });
  };

  closeModal = () => {
    this.setState({
      modalAnchor: null,
      focused: false,
    });

    this.blurInput();
  };

  blurInput = () => {
    setTimeout(() => {
      if (document.activeElement) {
        (document.activeElement as HTMLElement).blur();
      }
    }, 100);
  };

  onDateChange = (date: any) => {
    this.setState({
      date,
    });

    this.props.onChange(date);
    this.closeDatePicker();
  };

  closeDatePicker = () => {
    this.setState({
      modalAnchor: null,
      focused: false,
    });
  };

  clearDate = () => {
    this.setState({
      date: null,
      modalAnchor: null,
    });

    this.props.onChange(null);
  };

  onPickerFocusChange = (focused: any) => {
    let newStates = {
      focused: focused.focused,
      modalAnchor: this.state.modalAnchor,
    };

    if (!focused.focused) {
      newStates.modalAnchor = null;
      this.blurInput();
    }

    this.setState(newStates);
  };

  getTextValue = () => {
    let value = '';

    if (this.state.date !== null) {
      value += moment(this.state.date).format('MM/DD/YYYY');
    }

    return value;
  };

  renderPicker = () => {
    return (
      <Popover
        PaperProps={{
          style: {
            boxShadow: 'none',
            border: '1px solid #C6C8CC',
          },
        }}
        open={Boolean(this.state.modalAnchor) && this.state.focused}
        onClose={this.closeModal}
        anchorEl={this.state.modalAnchor}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
      >
        <div className="singleDatePicker">
          <DatePicker
            selected={this.state.date}
            enableTabLoop={false}
            onChange={this.onDateChange}
            open={this.state.focused}
            onClickOutside={this.closeDatePicker}
            formatWeekDay={(day) => day.substring(0, 1)}
            onBlur={this.onPickerFocusChange}
            shouldCloseOnSelect={true}
            renderCustomHeader={({
              date,
              changeYear,
              changeMonth,
              decreaseMonth,
              increaseMonth,
              prevMonthButtonDisabled,
              nextMonthButtonDisabled,
            }) => (
              <div className="custom-header">
                <button
                  onClick={decreaseMonth}
                  disabled={prevMonthButtonDisabled}
                  className="custom-nav-button"
                >
                  <BackIcon />
                </button>
                <select
                  value={date.getMonth()}
                  onChange={({ target: { value } }) =>
                    changeMonth(parseInt(value, 10))
                  }
                  className="custom-dropdown"
                >
                  {[
                    'January',
                    'February',
                    'March',
                    'April',
                    'May',
                    'June',
                    'July',
                    'August',
                    'September',
                    'October',
                    'November',
                    'December',
                  ].map((month, index) => (
                    <option
                      key={index}
                      value={index}
                    >
                      {month}
                    </option>
                  ))}
                </select>
                <select
                  value={date.getFullYear()}
                  onChange={({ target: { value } }) =>
                    changeYear(parseInt(value, 10))
                  }
                  className="custom-dropdown"
                >
                  {Array.from(
                    { length: 100 },
                    (_, i) =>
                      new Date(this.props.maxYear || new Date()).getFullYear() -
                      99 +
                      i,
                  ).map((year) => (
                    <option
                      key={year}
                      value={year}
                    >
                      {year}
                    </option>
                  ))}
                </select>
                <button
                  onClick={increaseMonth}
                  disabled={nextMonthButtonDisabled}
                  className="custom-nav-button"
                >
                  <ForwardIcon />
                </button>
              </div>
            )}
            dateFormat="yyyy-MM-dd"
          />
        </div>
      </Popover>
    );
  };

  render() {
    let className = styles.datePicker;

    if (this.props.className) {
      className = cx(styles.datePicker, this.props.className);
    }

    return (
      <div
        className={className}
        ref={(r: any) => (this.containerRef = r)}
      >
        <TextField
          disabled={this.props.disabled}
          margin="normal"
          error={Boolean(this.props.error)}
          helperText={this.props.error}
          onClick={this.openModal}
          label={this.props.label}
          variant="outlined"
          fullWidth={true}
          value={this.getTextValue()}
          id={this.props.id ? this.props.id : ''}
          InputProps={{
            readOnly: true,
          }}
        />
        {this.renderPicker()}
      </div>
    );
  }
}

export default DatePickerComponent;
